"use strict";

exports.__esModule = true;
exports.EditTitleSection = EditTitleSection;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _FormGroupField = require("../../Form/FormGroupField");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function EditTitleSection() {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  function validateTitle(value) {
    if (!value || !value.trim()) {
      return translate("TicketDetailsEditForm.titleError", "Title is required.");
    }
  }
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
    heading: translate("TicketDetailsEditForm.description", "Description"),
    content: /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "title",
      validate: validateTitle
    }, function (_ref) {
      var input = _ref.input;
      return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
        fill: true,
        style: {
          height: "100px"
        }
      }, input));
    })
  });
}